
export enum TournamentStatus { DRAFT = 'Draft', ACTIVE = 'Active', COMPLETE = 'Complete', ABANDONED = 'Abandoned' }
export enum BadgeType {
  GIANT_KILLER = 'giant_killer', MARATHON_MAN = 'marathon_man', THE_SWEEPER = 'the_sweeper',
  DONUT = 'donut', PICK_EM_PROPHET = 'pick_em_prophet', THE_LAZARUS = 'the_lazarus',
  ICE_VEINS = 'ice_veins', THE_WALL = 'the_wall', RENT_FREE = 'rent_free',
  IRON_MAN = 'iron_man', ROAD_WARRIOR = 'road_warrior', CALCULATED = 'calculated'
}
export enum Season { SPRING = 'Spring', SUMMER = 'Summer', FALL = 'Fall', WINTER = 'Winter', CHRISTMAS = 'Christmas' }

export type GameMode = 'singles' | 'doubles';

export interface PlayerStats {
  wins: number; losses: number; championships: number; pointsWon: number; pointsLost: number; matchesPlayed: number;
  majorTitles: number; minorTitles: number;
}
export interface PlayerAdvancedStats {
  clutchWins: number; clutchTotal: number; nemesisId: string | null; nemesisWinPct: number;
  longestStreak: number; currentStreak: number; peakElo: number; form: string[];
  
  // V14.0 Deep Stats
  servicePointsWon: number;
  servicePointsTotal: number;
  returnPointsWon: number;
  returnPointsTotal: number;
  aces: number;
  winners: number;
  errors: number;
  totalPointsPlayed: number;
  deuceWins: number;
  deuceTotal: number;
  gamePointsConverted: number;
  gamePointOpportunities: number;
  cleanSheets: number;
}
export interface Player {
  id: string; name: string; hometown: string; elo: number; stats: PlayerStats;
  advancedStats: PlayerAdvancedStats; badges: Record<string, number>; isArchived: boolean;
  avatarUrl?: string; isGuest?: boolean;
}
export interface Team extends Player {
  memberIds: string[];
}

export interface MatchMedia {
  id: string;
  type: 'image' | 'video';
  url: string;
  caption?: string;
  timestamp: number;
}

export interface MatchHistoryPoint {
  score1: number; score2: number; winProb1: number; server: string; timestamp: number;
  tag?: 'Ace' | 'Winner' | 'Edge' | 'Error';
  p1Elo?: number; p2Elo?: number;
}
export interface Match {
  id: string; tournamentId: string | null; player1Id: string; player2Id: string;
  firstServerId: string; score1: number; score2: number; winnerId: string | null;
  isGuest: boolean; isWalkover: boolean; startTime: number; endTime?: number;
  history: MatchHistoryPoint[]; eloChange?: { p1: number; p2: number };
  media?: MatchMedia[];
  p1EloAfter?: number;
  p2EloAfter?: number;
}
export interface TournamentMatch {
  id?: string; p1: string; p2: string; s1: number; s2: number; round: string;
  isWalkover?: boolean; winner?: string; nextMatchId?: string | null;
  nextMatchSlot?: 'p1' | 'p2' | null; history?: MatchHistoryPoint[];
  matchPointVideoUrl?: string; eloChange?: { p1: number; p2: number };
  media?: MatchMedia[];
  p1EloAfter?: number;
  p2EloAfter?: number;
  // Double Elim specific routing
  loserNextMatchId?: string | null;
  loserNextMatchSlot?: 'p1' | 'p2' | null;
  bracketGroup?: 'winners' | 'losers' | 'final';
}
export interface Tournament {
  id: string; name: string; season: Season; year: number; date: string;
  status: TournamentStatus; isMajor?: boolean; size?: number;
  format?: 'Single Elim' | 'Round Robin' | 'Double Elim'; bracketData?: any; videoUrl?: string;
  participants?: string[]; winnerId?: string; matches: TournamentMatch[];
}
export interface BadgeDefinition {
  id: string; name: string; description: string; icon: string; criteria: string; frequency: 'Repeatable' | 'Once';
}
export interface NewsArticle {
  id: string; headline: string; content: string; summary: string; author: string;
  date: string; tags: string[]; isBreaking?: boolean; relatedMatchId?: string;
  relatedTournamentId?: string;
}
